import React from 'react';
import { useInView } from 'react-intersection-observer';
import { isMobile } from 'mobile-device-detect';
import '../../styles/about/projectgoals.css';
import { ReactComponent as GlobeIcon } from '../../assets/svg/globe.svg';
import { ReactComponent as HumanIcon } from '../../assets/svg/human.svg';
import { ReactComponent as LaboratoryIcon } from '../../assets/svg/laboratory-tools.svg';

const ProjectGoalsSection = () => {
	const { ref: goalsSectionRef, inView: isVisible } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	});

	return (
		<section
			id="goals"
			className={`project-goals ${!isMobile && isVisible ? 'animate' : ''}`}
			ref={goalsSectionRef}
		>
			<h1>Our Goals and Vision</h1>
			<p>
				ProMS envisions a future where proteomics transforms cancer diagnostics
				and treatment, ensuring precision care tailored to individual patients.
			</p>
			<div className="goals">
				<div
					className={`goal ${isVisible ? 'goal-animate' : ''}`}
					style={{ animationDelay: '0s' }}
				>
					<GlobeIcon className="icon" />
					<p>Establish Sweden as a global leader in proteome medicine.</p>
				</div>
				<div
					className={`goal ${isVisible ? 'goal-animate' : ''}`}
					style={{ animationDelay: '0.5s' }}
				>
					<LaboratoryIcon className="icon" />
					<p>Develop a harmonized clinical proteomics platform.</p>
				</div>
				<div
					className={`goal ${isVisible ? 'goal-animate' : ''}`}
					style={{ animationDelay: '1s' }}
				>
					<HumanIcon className="icon" />
					<p>
						Conduct observational cancer trials to validate
						proteomics-based diagnostics.
					</p>
				</div>
			</div>
		</section>
	);
};

export default ProjectGoalsSection;
